window.MTGGoldfishDygraph = window.MTGGoldfishDygraph || {};

function fetchScript(url, params, options) {
  options = options || {};
  var fullUrl = url + '?' + new URLSearchParams(params).toString();
  if (options.before) options.before();
  fetch(fullUrl, {
    method: options.method || 'GET',
    headers: {
      'Accept': 'text/javascript, application/javascript, */*; q=0.01',
      'X-Requested-With': 'XMLHttpRequest'
    },
    credentials: 'same-origin'
  }).then(function(res) {
    return Promise.all([res, res.text()]);
  }).then(function(result) {
    var res = result[0];
    var js = result[1];
    var contentType = (res.headers.get('content-type') || '').toLowerCase();
    if (!res.ok || contentType.indexOf('javascript') === -1) {
      throw new Error('Expected JavaScript from ' + res.url + ' but received ' + (contentType || 'unknown content type'));
    }
    var script = document.createElement('script');
    script.textContent = js;
    document.head.appendChild(script);
    document.head.removeChild(script);
    if (options.complete) options.complete();
  }).catch(function(error) {
    console.error(error);
    if (options.complete) options.complete();
  });
}

window.MTGGoldfishDygraph.bindGraphHandlers = function(type) {
  if (typeof window.priceChartDygraph != 'undefined') {
    window.priceChartDygraph.updateOptions({
      annotationMouseOverHandler: function(annotation, point, dygraph, event) {
        var graphdiv = document.getElementById("graphdiv-online");
        if (graphdiv) graphdiv.style.cursor = 'pointer';
        var annotDiv = annotation.div;
        var rect = annotDiv.getBoundingClientRect();
        var topOffset = rect.top + window.scrollY;
        var leftOffset = rect.left + window.scrollX + annotDiv.clientWidth / 2;

        var el = document.querySelector('#price-event-annotation');
        if (el) {
          el.setAttribute('data-content', "<div class='pricing_event_popup'>" + annotation.text + "</div>");
          el.style.top = (topOffset - 10) + 'px';
          el.style.left = leftOffset + 'px';
          bootstrap.Popover.getOrCreateInstance(el).show();
        }
      },
      annotationMouseOutHandler: function(annotation, point, dygraph, event) {
        var graphdiv = document.getElementById("graphdiv-online");
        if (graphdiv) graphdiv.style.cursor = 'auto';
        var el = document.querySelector('#price-event-annotation');
        if (el) bootstrap.Popover.getOrCreateInstance(el).hide();
      },
      annotationClickHandler: function(annotation, point, dygraph, event) {
        window.open(annotation.link, '_blank');
      }
    });
  }
};

window.MTGGoldfishDygraph.syncHideSetIconsCheckboxes = function() {
  var checked = Cookies.get('hide-set-icons') === 'true';
  document.querySelectorAll('.hide-set-icons-checkbox').forEach(function(cb) { cb.checked = checked; });
};

window.MTGGoldfishDygraph.renderAnnotations = function(type) {
  if (typeof window.priceChartDygraph != 'undefined') {
    if (Cookies.get('hide-set-icons') === 'true') {
      window.priceChartDygraph.setAnnotations([]);
      return;
    }
    if (type == "online") {
      window.priceChartDygraph.setAnnotations(window.MTGGoldfishDygraph.annotationsOnline);
    } else {
      window.priceChartDygraph.setAnnotations(window.MTGGoldfishDygraph.annotationsPaper);
    }
  }
};

function initializeDefaultColumns(preference) {
  var container = document.querySelector(".card-container-controls-container .column-selector-container");
  if (!container) return;

  var activeColumns = ["name", "price_" + preference];
  if (window.matchMedia("screen and (min-width: 900px)").matches) {
    activeColumns = ["card_num", "name", "cost", "rarity", "price_" + preference, "price_changes_" + preference];
  } else if (window.matchMedia("screen and (min-width: 700px)").matches) {
    activeColumns = ["card_num", "name", "cost", "price_" + preference];
  } else if (window.matchMedia("screen and (min-width: 500px)").matches) {
    activeColumns = ["name", "cost", "price_" + preference];
  }

  container.querySelectorAll('input').forEach(function(input) {
    var key = input.value;
    var checked = input.checked;
    if (checked && !activeColumns.includes(key)) {
      input.click();
    } else if (!checked && activeColumns.includes(key)) {
      input.click();
    }
  });
}

function visibleDisplayValue(el) {
  if (!el) return 'block';
  return ['A', 'B', 'I', 'IMG', 'SPAN', 'STRONG'].includes(el.tagName) ? 'inline' : 'block';
}

function setElementsDisplay(selector, show) {
  document.querySelectorAll(selector).forEach(function(el) {
    el.style.display = show ? visibleDisplayValue(el) : 'none';
  });
}

function triggerTypePreferenceOnChange(newValue) {
  console.log("triggerTypePreferenceOnChange newValue=" + newValue);
  newValue = newValue.replace("#", "");
  var textarea = document.querySelector('#card-container-type_preference');
  if (textarea) {
    var nativeTextAreaValueSetter = Object.getOwnPropertyDescriptor(window.HTMLSelectElement.prototype, "value").set;
    nativeTextAreaValueSetter.call(textarea, newValue);
    var event2 = new Event('change', { bubbles: true });
    textarea.dispatchEvent(event2);
  }
}

window.MTGGoldfishDygraph.onDocumentReady = function() {
  console.log("price_chart onDocumentReady");

  var priceAnnotationEl = document.querySelector('#price-event-annotation');
  if (priceAnnotationEl) {
    new bootstrap.Popover(priceAnnotationEl, { trigger: 'focus', html: true });
  }

  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(function(el) {
    new bootstrap.Tooltip(el);
  });

  document.querySelectorAll(".btn-price-card-show-buy").forEach(function(btn) {
    btn.addEventListener('click', function() {
      setElementsDisplay(".price-card-sell-prices", false);
      setElementsDisplay(".price-card-buy-prices", true);
    });
  });

  document.querySelectorAll(".btn-price-card-show-sell").forEach(function(btn) {
    btn.addEventListener('click', function() {
      setElementsDisplay(".price-card-sell-prices", true);
      setElementsDisplay(".price-card-buy-prices", false);
    });
  });

  document.addEventListener('shown.bs.tab', function(e) {
    var tabEl = e.target;
    if (!tabEl.matches('#priceHistoryTabs a[data-bs-toggle="tab"], #dropdown-type-selector a[data-bs-toggle="tab"]')) return;
    var hash = tabEl.getAttribute('href') || '';
    var target = hash.replace("#tab-", "");
    var other = (target == "online") ? "paper" : "online";

    setElementsDisplay('.price-card-statistics-' + target, true);
    setElementsDisplay('.price-card-statistics-' + other, false);

    var collectionType = document.getElementById('collectionAdd-type');
    if (collectionType) collectionType.value = target;
    var priceAlertType = document.getElementById('price_alert_type');
    if (priceAlertType) priceAlertType.value = target;

    var navLink = document.querySelector("#dropdown-type-selector .nav-link");
    if (navLink) updateDropdownTypeToggle(navLink, target, tabEl.textContent.trim());
  });

  document.querySelectorAll('#priceHistoryTabs a[data-bs-toggle="tab"], #dropdown-type-selector a[data-bs-toggle="tab"]').forEach(function(el) {
    el.addEventListener('click', function(e) {
      e.preventDefault();
      bootstrap.Tab.getOrCreateInstance(el).show();
      console.log("e.target=" + e.target);
      var hash = el.getAttribute('href') || '';
      var target = hash.replace('#tab-', '#');
      triggerTypePreferenceOnChange(target);
      if (history.pushState) {
        history.pushState(null, null, target);
      } else {
        window.location.hash = target;
      }
    });
  });

  // do modal stuff first before online/paper stuff
  var url = document.location.toString();
  if (url.match('#modal-')) {
    var modal = url.split('#')[1];
    var modalEl = document.getElementById(modal);
    if (modalEl) bootstrap.Modal.getOrCreateInstance(modalEl).show();
  }

  var preference = null;
  if (url.match('#')) {
    preference = url.split('#')[1];
  }

  if (preference != "online" && preference != "paper") {
    preference = Cookies.get('type-preference');
    if (preference != "paper") {
      preference = "online";
    }
  }

  var prefTab = document.querySelector('#priceHistoryTabs a[href="#tab-' + preference + '"]');
  if (prefTab) {
    history.replaceState(null, null, '#' + preference);
    bootstrap.Tab.getOrCreateInstance(prefTab).show();
  } else {
    var firstTab = document.querySelector('a[data-bs-toggle="tab"]');
    var href = firstTab ? firstTab.getAttribute('href') : null;
    var hash = href ? href.replace('#tab-', '#') : '';
    if (hash !== '') {
      history.replaceState(null, null, hash);
      bootstrap.Tab.getOrCreateInstance(firstTab).show();
    }
  }

  window.addEventListener("popstate", function(e) {
    var popUrl = document.location.toString();
    if (popUrl.match('#')) {
      var tabEl = document.querySelector('#priceHistoryTabs a[href="#tab-' + popUrl.split('#')[1] + '"]');
      if (tabEl) bootstrap.Tab.getOrCreateInstance(tabEl).show();
    }
  });

  document.querySelectorAll(".price-played-with-select").forEach(function(select) {
    select.addEventListener('change', function() {
      var selected = select.options[select.selectedIndex];
      if (!selected) return;
      var format = selected.value;
      var card = selected.dataset.card;
      var blocker = document.getElementById("blocker");
      fetchScript("/played_with_js", { format: format, card: card }, {
        method: 'POST',
        before: function() { if (blocker) blocker.style.display = visibleDisplayValue(blocker); },
        complete: function() { if (blocker) blocker.style.display = 'none'; }
      });
    });
  });

  triggerTypePreferenceOnChange(preference);

  // Set icons toggle — use event delegation so dynamically-loaded checkboxes work
  document.addEventListener('change', function(e) {
    if (!e.target || !e.target.matches('.hide-set-icons-checkbox')) return;
    var checked = e.target.checked;
    document.querySelectorAll('.hide-set-icons-checkbox').forEach(function(cb) { cb.checked = checked; });
    Cookies.set('hide-set-icons', checked ? 'true' : 'false', { expires: 3650, path: '/' });
    if (typeof window.priceChartDygraph !== 'undefined') {
      if (checked) {
        window.priceChartDygraph.setAnnotations([]);
      } else {
        var currentType = Cookies.get('type-preference') === 'paper' ? 'paper' : 'online';
        var annotations = currentType === 'paper'
          ? (window.MTGGoldfishDygraph.annotationsPaper || [])
          : (window.MTGGoldfishDygraph.annotationsOnline || []);
        window.priceChartDygraph.setAnnotations(annotations);
      }
    }
  });
};
